/*
 *
 * CollaboratorsCreate actions
 *
 */

import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  CREATE_COLLABORATOR_WATCHER,
  CREATE_COLLABORATOR_SUCCESS,
  CREATE_COLLABORATOR_FAILED,
  GET_GENDERS_WATCHER,
  GET_GENDERS_SUCCESS,
  GET_GENDERS_FAILED,
  GET_EMPLOYEES_WATCHER,
  GET_EMPLOYEES_SUCCESS,
  GET_EMPLOYEES_FAILED,
  GET_CATEGORIES_WATCHER,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILED,
  GET_LOCATIONS_WATCHER,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILED
} from "./constants"

export const getDivisionsWatcher = () => {
  return { type: GET_DIVISIONS_WATCHER }
}

export const getDivisionsSuccess = (payload) => {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export const getDivisionsFailed = () => {
  return { type: GET_DIVISIONS_FAILED }
}

export const getGendersWatcher = () => {
  return { type: GET_GENDERS_WATCHER }
}

export const getGendersSuccess = (payload) => {
  return { type: GET_GENDERS_SUCCESS, payload }
}

export const getGendersFailed = (payload) => {
  return { type: GET_GENDERS_FAILED, payload }
}


export const getEmployeesWatcher = () => {
  return { type: GET_EMPLOYEES_WATCHER }
}

export const getEmployeesSuccess = (payload) => {
  return { type: GET_EMPLOYEES_SUCCESS, payload }
}

export const getEmployeesFailed = (payload) => {
  return { type: GET_EMPLOYEES_FAILED, payload }
}


export const getCategoriesWatcher = () => {
  return { type: GET_CATEGORIES_WATCHER }
}

export const getCategoriesSuccess = (payload) => {
  return { type: GET_CATEGORIES_SUCCESS, payload }
}

export const getCategoriesFailed = (payload) => {
  return { type: GET_CATEGORIES_FAILED, payload }
}


export const getLocationsWatcher = () => {
  return { type: GET_LOCATIONS_WATCHER }
}

export const getLocationsSuccess = (payload) => {
  return { type: GET_LOCATIONS_SUCCESS, payload }
}

export const getLocationsFailed = (payload) => {
  return { type: GET_LOCATIONS_FAILED, payload }
}


export const createCollaboratorWatcher = (payload) => {
  return {
    type: CREATE_COLLABORATOR_WATCHER,
    payload,
  }
}

export const createCollaboratorEnd = () => {
  return { type: CREATE_COLLABORATOR_SUCCESS }
}

export const createCollaboratorFailed = () => {
  return { type: CREATE_COLLABORATOR_FAILED }
}
